import {
    ListingLevel,
    ManufacturerProductCatalogDetail,
    ManufacturerProductSpecDocDetail,
} from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'
import { ViewDocumentRow } from './ViewDocumentRow'

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        marginTop: theme.spacing(5),
    },

    title: {
        color: '#04325B',
        fontWeight: 500,
        borderBottom: '6px solid #04325B',
        textTransform: 'uppercase',
    },
    itemContainer: {
        width: '80%',
    },

    tableHead: {
        backgroundColor: '#343334',
    },
    tableWhiteText: {
        color: '#FFF',
        fontWeight: 500,
    },
    documentHeading: {
        marginRight: theme.spacing(3),
        textTransform: 'uppercase',
        fontSize: pxToRem(13),
        fontWeight: 500,
        marginTop: theme.spacing(1),
        width: 85,
    },
    tableBody: {
        borderBottom: '1px solid #C9C9C9',
        '& .MuiTableCell-sizeSmall:last-child': {
            paddingRight: 0,
            paddingTop: theme.spacing(0.625),
            paddingBottom: theme.spacing(0.625),
        },
    },
}))

interface ViewDocumentsProps {
    level?: ListingLevel
    catalog?: Partial<ManufacturerProductCatalogDetail>
    longDocType?: Partial<ManufacturerProductSpecDocDetail>
    shortDocType?: Partial<ManufacturerProductSpecDocDetail>
}

export const ViewDocuments: React.FC<ViewDocumentsProps> = ({
    level,
    catalog,
    longDocType,
    shortDocType,
}) => {
    const classes = useStyles()
    if (!level || level === ListingLevel.Manufacturer) return null
    if (!catalog && !longDocType && !shortDocType) return null

    return (
        <GridContainer
            data-testid="documentHeading"
            className={classes.container}
        >
            <Typography variant="body1" className={classes.documentHeading}>
                Documents:
            </Typography>
            <GridItem className={clsx(classes.itemContainer)}>
                <Table size="small">
                    <TableBody className={classes.tableBody}>
                        {longDocType && (
                            <ViewDocumentRow
                                icon="longform"
                                text="Full Length Document"
                                level={level}
                                title={longDocType.title}
                                link={longDocType.path}
                            />
                        )}
                        {shortDocType && (
                            <ViewDocumentRow
                                icon="shortform"
                                text="Short Form Document"
                                level={level}
                                title={shortDocType.title}
                                link={shortDocType.path}
                            />
                        )}
                        {catalog && (
                            <ViewDocumentRow
                                icon="catalog"
                                text="Catalog"
                                level={level}
                                title={catalog.title}
                                link={catalog.path}
                            />
                        )}
                    </TableBody>
                </Table>
            </GridItem>
        </GridContainer>
    )
}
